import bodybuilder from 'bodybuilder';
import _ from 'lodash';
import moment from 'moment';

export const maskedInfo = '****';

export const fetchSameOrigin = (url, method = 'GET', options = {}, headers = {}) => {
  const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute('content');
  const reqHeaders = {
    'Content-Type': 'application/json',
    'X-CSRF-Token': csrfToken,
    ...headers
  };
  return window.fetch(url, {
    method,
    credentials: 'same-origin',
    headers:     reqHeaders,
    ...options
  });
};

export function filtersToEsQuery(filters){
  const esQuery = bodybuilder();
  _.each(filters, function(value, key){
    if(Boolean(value)){
      let snakeKey = _.snakeCase(key);
      switch(key){
        case 'firstName':
          esQuery.query("fuzzy", snakeKey, { value: _.toLower(value), fuzziness: 'AUTO'});
          break;
        case 'lastName':
          esQuery.query("fuzzy", snakeKey, { value: _.toLower(value), fuzziness: 'AUTO'});
          break;
        case 'username':
          esQuery.query("match", snakeKey, value);
          break;
        case 'zipCode':
          esQuery.query("wildcard", snakeKey, _.toUpper(value)+"*");
          break;
        case 'city':
          esQuery.query("fuzzy", snakeKey, { value, fuzziness: 'AUTO'});
          break;
        case 'emailAddress':
          esQuery.query("wildcard", 'email_addresses', _.toLower(value)+"*");
          break;
        case 'address':
          esQuery.filter("fuzzy", 'address_line1', { value, fuzziness: 'AUTO'});
          break;
        case 'phoneNumber':
          esQuery.query("wildcard", 'phone_numbers', _.toLower(value)+"*");
          break;
        case 'memberId':
          esQuery.orQuery("match", snakeKey, value);
          esQuery.orQuery("match", 'health_plan_ids', value);
          esQuery.queryMinimumShouldMatch(1);
          break;
        case 'dob':
          if(moment(value).isValid()){
            esQuery.filter("term", snakeKey, _.toLower(moment(value).format("YYYY-MM-DD")));
          }
          break;
        default:
          if(Array.isArray(value)){
            _.each(value, function(i){
              if(Boolean(i)){
                esQuery.query("match", snakeKey, i);
              }
            });
          }else{
            esQuery.query("match", snakeKey, value);
          }
          break;
      }
    }else{
      return null;
    }
  });
  esQuery.filter('term', 'valid_db_record', true);
  if (!filters.status) {
    esQuery.query('match', 'status', 'MEMBERSTATUS_ACT');
  }
  esQuery.size(50);
  return esQuery.build();
}

export const parseData = (propertyName) => {
  return document.querySelector(`meta[property='${propertyName}']`).getAttribute('content');
}

export const isMemberRestricted = (groupIds) => {
  const restrictedGroups = parseData('staticData:restrictedGroups');
  return groupIds.some( groupId => restrictedGroups.split(',').includes(groupId));
}

export const hasfullTdMembersAccess = (isRestricted) => {
  const fullAccess = JSON.parse(parseData('roles:houseFull'));
  return (!isRestricted || fullAccess);
}

export const hasImpersonationAccess = () => {
  const hasImpersonationAccess = JSON.parse(parseData('roles:impersonator'));
  return hasImpersonationAccess === true || hasImpersonationAccess === 'true';
}

export const hasLimitedPhiAccess = (isRestricted) => {
  const limitedPhiAccess = JSON.parse(parseData('roles:limitedPhi'));
  return (!isRestricted || limitedPhiAccess);
}

export const hasLimitedPiAccess = (isRestricted) => {
  const limitedPiAccess = JSON.parse(parseData('roles:limitedPi'));
  return (!isRestricted || limitedPiAccess);
}

export const maskData = (data, hasAccess) => (hasAccess ? data : maskedInfo);

export function featureActive(featureFlag){
  try {
    const result = document.querySelector(`meta[property='featureToggles:${featureFlag}']`).getAttribute("content") == "true";
    return result;
  } catch (e) {
    console.error('FLAG NOT FOUND!');
    return false;
  }
}

export function downloadBlob(blob, filename) {
  const triggerURL = window.URL.createObjectURL(blob);
  const trigger = document.createElement('a');

  trigger.style.display = 'none';
  trigger.href = triggerURL;
  trigger.download = filename;

  document.body.appendChild(trigger);
  trigger.click();

  window.URL.revokeObjectURL(triggerURL);
  trigger.remove();
}

export function isAdult(dob) {
  return ( moment().diff(dob, 'years', false) > 18 );
}

export const camelizeKeys = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(v => camelizeKeys(v));
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [_.camelCase(key)]: camelizeKeys(obj[key]),
      }),
      {},
    );
  }
  return obj;
};

